/* __next_internal_client_entry_do_not_use__ Default,PreFooter auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Global
import { tv } from 'tailwind-variants';
import { useRef } from 'react';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { useScrollElementIntoView } from 'lib/hooks/useScrollElementIntoView';
import { findComponent } from 'lib/utils/object-utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
export const Default = (props)=>{
    const isEditing = useIsEditing();
    const { RenderingIdentifier } = props?.params || {};
    const { base } = TAILWIND_VARIANTS();
    const mainLayoutRef = useRef(null);
    useScrollElementIntoView(mainLayoutRef.current, {
        stickyHeaderId: 'header',
        scrollTargetId: 'main-content'
    });
    const isSearchLayout = findComponent(props.rendering, 'ArticleMain')?.length > 0 || findComponent(props.rendering, 'SearchResult')?.length > 0;
    return /*#__PURE__*/ _jsxs("div", {
        ref: mainLayoutRef,
        className: base({
            isSearchLayout: isSearchLayout
        }),
        "data-component": "authorable/shared/site-structure/main-layout/mainlayout",
        ...editingHydrationProps(isEditing),
        id: RenderingIdentifier,
        children: [
            /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                helpTextHideIf: true,
                name: "custom-headless-breadcrumb",
                rendering: props.rendering
            }),
            /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                name: "custom-headless-hero",
                rendering: props.rendering
            }),
            /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                name: "custom-headless-main-content",
                rendering: props.rendering
            }),
            /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                name: "custom-headless-livechat",
                rendering: props.rendering
            })
        ]
    });
};
export const PreFooter = (props)=>{
    const isEditing = useIsEditing();
    const { RenderingIdentifier } = props?.params || {};
    const { base } = TAILWIND_VARIANTS();
    const mainLayoutRef = useRef(null);
    const isSearchLayout = findComponent(props.rendering, 'ArticleMain')?.length > 0 || findComponent(props.rendering, 'SearchResult')?.length > 0;
    return /*#__PURE__*/ _jsx("div", {
        ref: mainLayoutRef,
        className: base({
            isSearchLayout: isSearchLayout
        }),
        "data-component": "authorable/shared/site-structure/main-layout/mainlayout",
        ...editingHydrationProps(isEditing),
        id: RenderingIdentifier,
        children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
            name: "custom-headless-pre-footer",
            rendering: props.rendering
        })
    });
};
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'grid',
            'grid-cols-1',
            'm-auto',
            'w-full',
            'max-w-screen-dimensions-max-width',
            'min-w-screen-dimensions-min-width',
            'px-general-spacing-margin-x'
        ]
    },
    variants: {
        isSearchLayout: {
            true: {
                base: [
                    'gap-0',
                    '!pb-general-spacing-margin-y'
                ]
            }
        }
    }
});
